import { PermitTypeList } from '@src/orders/domain/PermitType';
import { PermitTypesClient } from '@src/orders/services/PermitTypesClient';
import { useQuery } from '@tanstack/react-query';

const getQueryKey = (permitApplicationId: string) => [
  'permitTypes.compatibleFor',
  permitApplicationId,
];

export const useCompatiblePermitTypes = (permitApplicationId: string) => {
  const { data: permitTypes = new PermitTypeList([]), isLoading } =
    useQuery<PermitTypeList>({
      queryKey: getQueryKey(permitApplicationId),
      queryFn: () => PermitTypesClient.listCompatibleFor(permitApplicationId),
    });

  return { permitTypes, isLoading };
};
